import { __rest } from "tslib";
import React from 'react';
import Flex from '../flex';
import { container, input } from './input.css';
import { cn, executeCallbacks } from '~/utils';
const INPUT_NAME = 'vulcanui-input';
const Input = React.forwardRef((props, ref) => {
    const { onChange, disabled, className, fullWidth, onValueChange, startContent, endContent, hideBorder } = props, restProps = __rest(props, ["onChange", "disabled", "className", "fullWidth", "onValueChange", "startContent", "endContent", "hideBorder"]);
    const handleChange = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(event.target.value);
    };
    return (React.createElement(Flex, { gap: "sm", justify: "start", align: "center", display: "inlineFlex", className: cn(`${INPUT_NAME}-container`, container({ disabled, fullWidth, hideBorder })) },
        startContent,
        React.createElement("input", Object.assign({ "aria-disabled": disabled, className: cn(INPUT_NAME, className, input), disabled: disabled, onChange: executeCallbacks(onChange, handleChange), ref: ref }, restProps)),
        endContent));
});
Input.displayName = 'Input';
Input.toString = () => `.${INPUT_NAME}`;
export default Input;
//# sourceMappingURL=input.js.map